export const READ_ONLY_MENU = [
    {
        name: 'Inicio',
        url: '/home',
        icon: 'fas fa-home'
    }
];
